var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('header',{staticClass:"page-header"},[_c('center',[_c('h1',{staticClass:"page-title-2"},[_vm._v("Will Be Updated!!!")])])],1),_c('div',{staticClass:"gap gap-big"}),_c('div',{staticClass:"gap gap-big"}),_c('div',{staticClass:"gap gap-small"})])
}
var staticRenderFns = []

export { render, staticRenderFns }